// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}

.header-menus {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 70px;
  height: 70px;
  flex-direction: row;
  margin-left: -5px;
  margin-top: 5px;
}

.header-menus a {
  text-decoration: none;
  color: #000000;
}

.header-menus h2 a:focus,
.header-menus h2 a:hover,
.header-menus h2 a:focus-visible {
  color: #017890 !important;
}

.menubar-logo img {
  background-color: white;
  margin-left: -75px;
  margin-right: 30px;
  margin-top: 0px;
  padding: 1px 20px;
  width: 150px;
  height: 45px;
  line-height: 70px;
}

.open-close-icon-theme2 {
  height: 70px;
  line-height: 90px;
  margin-top: -5px;
  margin-left: 7px;
}

.open-close-icon-theme2:hover,
.open-close-icon-theme3:hover {
  color: #017890;
}

.open-close-icon-theme3 {
  width: fit-content;
  height: 70px;
  line-height: 90px;
  margin-top: -15px;
  margin-left: 7px;
}

.col a:hover {
  color: black !important;
  transition-duration: 1s;
}

.profile-icon {
  padding-left: 10px;
  padding-right: -10px !important;
}

.setting-icon-menu {
  position: relative;
}

.Notification-icon span {
  color: "#FFFFFF" !important;
  background: "#017890" !important;
}

.menu-card {
  position: absolute;
  top: -430px;
  right: 95px;
  border: none;
  border-radius: 1px;
  width: 220px;
  z-index: 10;
}

.setting-menus {
  text-decoration: none;
  list-style: none;
}

.setting-menus li {
  padding: 5px;
}

.setting-menus li:hover {
  background-color: #017890;
}


/* add new on 22-07-2023 */
.activeLink {
  color: #017890 !important;
}


/* add new on 19-09-2023 */
.menus {
  position: relative;
}

.menu-items {
  position: absolute;
  top: 30px;
  font-size: 14px;
  color: #000000;
}

.menu-items a {
  width: max-content;
}



@media only screen and (max-width: 600px) {
  .menubar-logo img {
    background-color: white;
    margin-left: -45px;
    margin-top: 0px;
    padding: 15px 20px;
    width: 130px;
    height: 70px;
    line-height: 70px;
  }

  .open-close-icon-theme2 {
    height: 70px;
    line-height: 80px;
    margin-top: -8px;
    margin-left: 8px;
    margin-right: -8px;
  }

  .profile-icon {
    padding-left: 5px;
    padding-right: -10px !important;
  }
}

/* new change sir display size */
@media (min-width: 1979px) and (max-width: 2559px) {
  .Notification-icon {
    margin-left: -10px !important;
  }


}`, "",{"version":3,"sources":["webpack://./src/app/layouts/shared/headers/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;;AAGA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;;;AAIA;EACE;IACE,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,6BAA6B;EAC/B;;;AAGF","sourcesContent":["* {\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n}\n\n.header-menus {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  line-height: 70px;\n  height: 70px;\n  flex-direction: row;\n  margin-left: -5px;\n  margin-top: 5px;\n}\n\n.header-menus a {\n  text-decoration: none;\n  color: #000000;\n}\n\n.header-menus h2 a:focus,\n.header-menus h2 a:hover,\n.header-menus h2 a:focus-visible {\n  color: #017890 !important;\n}\n\n.menubar-logo img {\n  background-color: white;\n  margin-left: -75px;\n  margin-right: 30px;\n  margin-top: 0px;\n  padding: 1px 20px;\n  width: 150px;\n  height: 45px;\n  line-height: 70px;\n}\n\n.open-close-icon-theme2 {\n  height: 70px;\n  line-height: 90px;\n  margin-top: -5px;\n  margin-left: 7px;\n}\n\n.open-close-icon-theme2:hover,\n.open-close-icon-theme3:hover {\n  color: #017890;\n}\n\n.open-close-icon-theme3 {\n  width: fit-content;\n  height: 70px;\n  line-height: 90px;\n  margin-top: -15px;\n  margin-left: 7px;\n}\n\n.col a:hover {\n  color: black !important;\n  transition-duration: 1s;\n}\n\n.profile-icon {\n  padding-left: 10px;\n  padding-right: -10px !important;\n}\n\n.setting-icon-menu {\n  position: relative;\n}\n\n.Notification-icon span {\n  color: \"#FFFFFF\" !important;\n  background: \"#017890\" !important;\n}\n\n.menu-card {\n  position: absolute;\n  top: -430px;\n  right: 95px;\n  border: none;\n  border-radius: 1px;\n  width: 220px;\n  z-index: 10;\n}\n\n.setting-menus {\n  text-decoration: none;\n  list-style: none;\n}\n\n.setting-menus li {\n  padding: 5px;\n}\n\n.setting-menus li:hover {\n  background-color: #017890;\n}\n\n\n/* add new on 22-07-2023 */\n.activeLink {\n  color: #017890 !important;\n}\n\n\n/* add new on 19-09-2023 */\n.menus {\n  position: relative;\n}\n\n.menu-items {\n  position: absolute;\n  top: 30px;\n  font-size: 14px;\n  color: #000000;\n}\n\n.menu-items a {\n  width: max-content;\n}\n\n\n\n@media only screen and (max-width: 600px) {\n  .menubar-logo img {\n    background-color: white;\n    margin-left: -45px;\n    margin-top: 0px;\n    padding: 15px 20px;\n    width: 130px;\n    height: 70px;\n    line-height: 70px;\n  }\n\n  .open-close-icon-theme2 {\n    height: 70px;\n    line-height: 80px;\n    margin-top: -8px;\n    margin-left: 8px;\n    margin-right: -8px;\n  }\n\n  .profile-icon {\n    padding-left: 5px;\n    padding-right: -10px !important;\n  }\n}\n\n/* new change sir display size */\n@media (min-width: 1979px) and (max-width: 2559px) {\n  .Notification-icon {\n    margin-left: -10px !important;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
